import { iconMenu } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { useAppLayoutContext } from '../app-layout/index.js';
import { Icon } from '../icon/index.js';
import { NavItem } from '../nav-item/index.js';
export const InternalMenuTrigger = ({ className, onClick, ...rest }) => {
    const { toggleNav } = useAppLayoutContext();
    return (React.createElement(NavItem, { className: cx('tds-site-menu-btn', className), onClick: (e) => {
            toggleNav();
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }, icon: React.createElement(Icon, { data: iconMenu }), ...rest }));
};
